module.exports = require("./fr-TG.js");